'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _address = require('redux/modules/address');

var addressActions = _interopRequireWildcard(_address);

var _filter = require('redux/modules/filter');

var filterActions = _interopRequireWildcard(_filter);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _reduxForm = require('redux-form');

var _reactRouterRedux = require('react-router-redux');

var _lib = require('helpers/lib');

var _reactBootstrap = require('react-bootstrap');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = require('lodash');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WAIT_INTERVAL = 1000;
var ENTER_KEY = 13;
var SearchMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    provinces: state.address.provinces,
    province: state.address.province,
    categories: state.setup.categories,
    categoriesFilter: state.setup.categoriesFilter,
    query: state.filter.query,
    districts: state.address.districts,
    district_parent: state.address.district_parent,
    districts_loading: state.address.districts_loading,
    addressFilter: state.address.addressFilter,
    subCatFilter: state.setup.subCatFilter
  };
}, (0, _extends3.default)({}, addressActions, filterActions, setupActions, {
  initializeWithKey: _reduxForm.initializeWithKey,
  push: _reactRouterRedux.push
})), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(SearchMobile, _Component);

  function SearchMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SearchMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchMobile.__proto__ || (0, _getPrototypeOf2.default)(SearchMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: false,
      addressFilter: _this.props.addressFilter || [],
      categoriesFilter: _this.props.categoriesFilter || {},
      subCatFilter: _this.props.subCatFilter || {},
      query: '',
      focus: false
    }, _this.hanldeCheckedAddress = function (event) {
      _this.props.handleDistrictFilter(_this.props.addressFilter, String(event.target.name));
    }, _this.handleShowPopover = function () {
      _this.setState({
        target: function target() {
          return _reactDom2.default.findDOMNode(_this.refs.target);
        },
        show: !_this.state.show
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SearchMobile, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // TODO: set query lại rỗng khi vào trang home, vì trang search cũng dùng chung filter.query
      // Luồng ưu tiên Home => Search (1 chiều) nên vào home buộc phải clear giá trị.
      // this.props.changeQuery('');
      // this.setState({query: ''});
      this.timer = null;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (String(this.props.province) !== String(this.props.district_parent) && !this.props.districts_loading) {
        this.props.loadDistrict(this.props.province);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var flag = false;
      if (nextProps.addressFilter !== this.props.addressFilter) {
        flag = true;
        this.setState({ addressFilter: nextProps.addressFilter });
      }
      if (nextProps.query !== this.props.query) {
        this.setState({ query: nextProps.query });
      }
      if (nextProps.categoriesFilter !== this.props.categoriesFilter) {
        flag = true;
        this.setState({ categoriesFilter: nextProps.categoriesFilter });
      }
      if (nextProps.subCatFilter !== this.props.subCatFilter) {
        flag = true;
        this.setState({ subCatFilter: nextProps.subCatFilter });
      }
      if (flag) {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.getResult.bind(this), WAIT_INTERVAL);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (String(this.props.province) !== String(this.props.district_parent) && !this.props.districts_loading) {
        this.props.loadDistrict(this.props.province);
      }
    }
  }, {
    key: 'getResult',
    value: function getResult() {
      var filter = (0, _lib.processQuery)(this.state.query, this.props.province, this.props.addressFilter, this.props.categoriesFilter, this.props.subCatFilter);
      this.props.getSearchResult(filter);
    }
  }, {
    key: 'hanldleSearch',
    value: function hanldleSearch(event) {
      clearTimeout(this.timer);
      this.setState({ query: event.target.value });
      this.timer = setTimeout(this.triggerChange.bind(this), WAIT_INTERVAL);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      if (event.keyCode === ENTER_KEY) {
        event.preventDefault();
        this.triggerChange.call(this);
        this.setState({ query: '' });
        this.handleSubmit();
      }
    }
  }, {
    key: 'triggerChange',
    value: function triggerChange() {
      var query = this.state.query;

      this.props.changeQuery(query);
      var filter = (0, _lib.processQuery)(query, this.props.province, this.state.addressFilter, this.state.categoriesFilter, this.state.subCatFilter);
      this.props.getSearchResult(filter);
    }
  }, {
    key: 'handleChangeProvince',
    value: function handleChangeProvince(selectedOption) {
      if (selectedOption && selectedOption.value) {
        var _props = this.props,
            tracking = _props.tracking,
            province = _props.province,
            provinces = _props.provinces;

        if (province) {
          var pro = provinces.find(function (p) {
            return p.code === province;
          });
          this.props.manualTrack((0, _extends3.default)({}, tracking, { label: pro.name + ' => ' + selectedOption.label }));
        }
        if (selectedOption.value !== this.props.province) {
          this.props.changeProvince(selectedOption.value);
        }
      } else {
        this.props.changeProvince('79');
      }
      this.onBlur();
      this.selectProvince.input.blur();
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit() {
      // TODO: Change query theo state, để fix lỗi text_search bên categorymobile. Vì filter.query dùng chung.
      this.getResult.call(this);
      this.props.changeQuery(this.state.query);
      this.props.push('/kham-pha');
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      this.setState({ focus: true });
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      this.setState({ focus: false });
      document.activeElement.blur();
    }
  }, {
    key: 'getClass',
    value: function getClass(cls) {
      if (this.state.focus === true) {
        return cls;
      }
      return '';
    }
  }, {
    key: 'clearSearch',
    value: function clearSearch() {
      this.setState({ query: '' });
      this.props.changeQuery('');
      this.inputFocus.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./SearchMobile.scss');
      var _props2 = this.props,
          provinces = _props2.provinces,
          province = _props2.province;
      var query = this.state.query;

      var options = [];
      if (provinces && provinces.length) {
        for (var index = 0; index < provinces.length; index++) {
          if (provinces[index].code === '01' || provinces[index].code === '79') {
            options = (0, _lodash.concat)([{
              value: provinces[index].code,
              label: provinces[index].code === '79' ? 'Tp.HCM' : provinces[index].name
            }], options);
          } else {
            options.push({
              value: provinces[index].code,
              label: provinces[index].name
            });
          }
        }
      }
      return _react2.default.createElement(
        'div',
        {
          className: styles.mobileSearchBox + ' ' + this.getClass(styles.focus)
        },
        _react2.default.createElement('div', {
          className: styles.bgCover,
          onClick: this.onBlur.bind(this),
          onTouchMove: this.onBlur.bind(this)
        }),
        _react2.default.createElement(
          'div',
          { className: styles.searchBox },
          _react2.default.createElement(
            'div',
            {
              className: styles.searchGroup,
              id: 'search-mobile',
              onFocusCapture: this.onFocus.bind(this),
              onBlurCapture: this.onBlur.bind(this)
            },
            _react2.default.createElement(
              'button',
              {
                className: styles.searchButton,
                onClick: function onClick() {
                  return _this2.handleSubmit();
                }
              },
              _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'search' })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.searchValueBox },
              _react2.default.createElement('input', {
                ref: function ref(e) {
                  _this2.inputFocus = e;
                },
                className: styles.searchValue,
                type: 'text',
                name: 'search',
                placeholder: 'T\xECm ki\u1EBFm...',
                value: query,
                onChange: this.hanldleSearch.bind(this),
                onKeyDown: this.handleKeyDown.bind(this),
                style: { fontSize: '12px' }
              }),
              _react2.default.createElement('span', {
                className: styles.searchClear + ' ' + (query === '' ? 'hide' : ''),
                onClick: this.clearSearch.bind(this)
              })
            ),
            _react2.default.createElement(_reactSelect2.default, {
              ref: function ref(e) {
                _this2.selectProvince = e;
              },
              name: 'province',
              onFocus: this.onFocus.bind(this),
              placeholder: 'T\u1EC9nh Th\xE0nh',
              className: styles.searchProvince + ' homeProvince',
              value: province,
              onChange: this.handleChangeProvince.bind(this),
              options: options
              // multi={false}
              , searchable: false
            })
          )
        )
      );
    }
  }]);
  return SearchMobile;
}(_react.Component), _class2.propTypes = {
  provinces: _react.PropTypes.array,
  categories: _react.PropTypes.array,
  province: _react.PropTypes.string,
  districts: _react.PropTypes.array,
  addressFilter: _react.PropTypes.array,
  subCatFilter: _react.PropTypes.object,
  initializeWithKey: _react.PropTypes.func.isRequired,
  changeProvince: _react.PropTypes.func.isRequired,
  loadDistrict: _react.PropTypes.func.isRequired,
  query: _react.PropTypes.string,
  district_parent: _react.PropTypes.string,
  districts_loading: _react.PropTypes.bool,
  changeQuery: _react.PropTypes.func.isRequired,
  handleDistrictFilter: _react.PropTypes.func.isRequired,
  handleMainCat: _react.PropTypes.func.isRequired,
  handleSubCat: _react.PropTypes.func.isRequired,
  push: _react.PropTypes.func.isRequired,
  getSearchResult: _react.PropTypes.func.isRequired,
  position: _react.PropTypes.string,
  categoriesFilter: _react.PropTypes.object,
  tracking: _react.PropTypes.object,
  manualTrack: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = SearchMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Home/SearchMobile.js
// module id = 1607
// module chunks = 0